
/**
 * Avatar utilities — stores/retrieves user avatar as base64 data URL.
 * Checks the auth store's user object for avatar_url first, then falls back to localStorage.
 * Key format: wfm-avatar-{userId}
 */

const AVATAR_KEY_PREFIX = 'wfm-avatar-';

export function getAvatarKey(userId) {
  return `${AVATAR_KEY_PREFIX}${userId}`;
}

export function getStoredAvatar(userId) {
  if (!userId) return null;
  // Check auth store user object for avatar_url (persisted in localStorage by Zustand)
  try {
    const raw = localStorage.getItem('wfm-auth');
    if (raw) {
      const parsed = JSON.parse(raw);
      const avatarUrl = parsed?.state?.user?.avatar_url;
      if (avatarUrl) return avatarUrl;
    }
  } catch {
    // ignore
  }
  // Fall back to localStorage avatar cache
  try {
    return localStorage.getItem(getAvatarKey(userId)) || null;
  } catch {
    return null;
  }
}

export function setStoredAvatar(userId, dataUrl) {
  if (!userId) return;
  try {
    localStorage.setItem(getAvatarKey(userId), dataUrl);
  } catch {
    // localStorage full or unavailable
  }
}

export function removeStoredAvatar(userId) {
  if (!userId) return;
  try {
    localStorage.removeItem(getAvatarKey(userId));
  } catch {
    // ignore
  }
}

/**
 * Read a File as a base64 data URL. Returns a Promise<string>.
 */
export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Errore nella lettura del file'));
    reader.readAsDataURL(file);
  });
}
